import { MISSING_IMAGE_URL } from '@/components/ui/ui.constants';

export default function isMissingImage(url?: string | null): boolean {
  return !url || url === MISSING_IMAGE_URL;
}
